<section class="sce-promotion">
  <app-yes-no-dialog-box [visible]="true"
                         customContent="true"
                         customHeader="true"
                         [withoutCloseIcon]="true" size="xxlarge">
    <div header class="sce-promotion__header">
      <img alt="logo" class="sce-promotion__banner" src="assets/images/sce-promotion.png"/>
    </div>

    <div content>
      <section class="sce-promotion__polygons">
        <img alt="polygon" class="sce-promotion__top-polygon" src="assets/images/sce-top-polygon.png"/>
        <img alt="polygon" class="sce-promotion__center-polygon" src="assets/images/sce-center-polygon.png"/>
        <img alt="polygon" class="sce-promotion__bottom-polygon" src="assets/images/sce-bottom-polygon.png"/>
      </section>

      <section class="sce-promotion__promotion-content promotion-content">
        <section class="promotion-content__info-section info-section">
          <div class="info-section__info-block">
            <div class="info-section__info-title" [translate]="'sce-promotion.info-title'"></div>
            <div class="info-section__info-sub-title" [translate]="'sce-promotion.info-sub-title'"></div>
            <div class="info-section__info-desc">
              <div [translate]="'sce-promotion.info-desc-1'"></div>
              <div [translate]="'sce-promotion.info-desc-2'"></div>
              <div [translate]="'sce-promotion.info-desc-3'"></div>
            </div>
          </div>

          <div class="info-section__price-block">
            <div class="info-section__price-title" [translate]="'sce-promotion.pricing-fees'"></div>
            <div class="info-section__price-value" [translate]="'sce-promotion.pricing-value'"></div>
            <div class="info-section__price-desc">
              <div class="info-section__price-desc-item" [translate]="'sce-promotion.pricing-desc-1'"></div>
              <div class="info-section__price-desc-item" [translate]="'sce-promotion.pricing-desc-2'"></div>
              <div class="info-section__price-desc-item" [translate]="'sce-promotion.pricing-desc-3'"></div>
            </div>
            <div class="info-section__price-items">
              <div class="info-section__price-item" [translate]="'sce-promotion.activity-1'"></div>
              <div class="info-section__price-item" [translate]="'sce-promotion.activity-2'"></div>
              <div class="info-section__price-item" [translate]="'sce-promotion.activity-3'"></div>
              <div class="info-section__price-item" [translate]="'sce-promotion.activity-4'"></div>
            </div>
            <div class="info-section__cancel-info" [translate]="'sce-promotion.cancel-text'"></div>
          </div>
        </section>

        <section class="promotion-content__buttons-section buttons-section">
          <button class="btn btn-primary buttons-section__skip-button" [translate]="'shared.buttons.skip'"
                  (click)="action(promotionPopupDecisionType.Skip)" data-test="sce-promotion-skip"></button>
          <button class="btn btn-primary buttons-section__apply-button" [translate]="'shared.buttons.apply-now'"
                  (click)="action(promotionPopupDecisionType.Apply)" data-test="sce-promotion-apply"></button>
        </section>
      </section>
    </div>
  </app-yes-no-dialog-box>
</section>
